const $ = jQuery.noConflict();

export default function mobileNav() {
    const mobileNavInner = {
        triggerClick() {
            $(".mn-trigger").click(function onClick() {
                $("body").toggleClass("mn-active");
            });
        },

        menuItemClick() {
            $(
                ".mn-menu ul > li.menu-item-has-children > a, .toggle-sub-menu"
            ).click(function onClick(eventObject) {
                eventObject.preventDefault();
                $(this)
                    .parent()
                    .toggleClass("menu-item-open")
                    .find("> ul.sub-menu")
                    .slideToggle();
            });

            $(".mn-menu li:not(.menu-item-has-children) a").click(
                function onClick() {
                    $("body").removeClass("mn-active");
                }
            );
        },

        swipe() {
            $(".mn-menu").on("swiperight", function onSwipeRight() {
                $("body").removeClass("mn-active");
            });
        },

        init() {
            mobileNavInner.triggerClick();
            mobileNavInner.menuItemClick();
            mobileNavInner.swipe();
        },
    };

    mobileNavInner.init();
}
